import type { TextUIPart } from '@ai-sdk/ui-utils';
import type { Message } from '~/lib/.server/llm/providers/types';

type MessageParts = NonNullable<Message['parts']>;

export function redactArtifact(content: string, parts: MessageParts, replaceValue: string) {
  return replaceContent(content, parts, replaceArtifact, replaceValue);
}

export function redactActionsContent(content: string, parts: MessageParts, replaceValue: string) {
  return replaceContent(content, parts, replaceActionsContent, replaceValue);
}

function replaceContent(
  content: string,
  parts: MessageParts,
  replacer: (content: string, replaceValue: string) => string,
  replaceValue: string,
) {
  const newContent = replacer(content, replaceValue);

  const newParts = parts.map((part) => {
    if (part.type === 'text') {
      return {
        ...part,
        text: replacer(part.text, replaceValue),
      } as TextUIPart;
    }

    return part;
  });

  return { newContent, newParts };
}

function replaceArtifact(content: string, replaceValue: string) {
  return content.replace(/<boltArtifact[\s\S]*?<\/boltArtifact>/gm, replaceValue);
}

function replaceActionsContent(content: string, replaceValue: string) {
  return content.replace(
    /(<boltAction[^>]*>)([\s\S]*?)(<\/boltAction>)/gm,
    (_, openTag, _content, closeTag) => `${openTag}${replaceValue}${closeTag}`,
  );
}

export function extractBoltArtifactTitle(input: string) {
  const regex = /<boltArtifact[^>]*\btitle=["']([^"']*)["'][^>]*>/;
  const match = input.match(regex);

  return match ? match[1] : null;
}
